/**
 * DTO enum for project change sections
 * Maps to backend ProjectChangeSection enum
 */
export enum ProjectChangeSectionDTO {
  INFO = 'INFO',
  BILLING = 'BILLING',
  INTEGRATIONS = 'INTEGRATIONS',
}

export type ProjectChangeSectionRequest = ProjectChangeSectionDTO;
export type ProjectChangeSectionResponse = ProjectChangeSectionDTO;
